import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    height: 'auto',
    background: '#FFFFFF',
    boxShadow: '0px 1px 3px rgba(0,0,0,0.12), 0px 0px 0px 1px rgba(19,45,74,0.04)',
    borderRadius: '8px !important',
    position: 'relative',
    marginBottom: 16,
    '&:before': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      background: '#FFFFFF',
      boxShadow: '0px 1px 3px rgba(0,0,0,0.12), 0px 0px 0px 1px rgba(19,45,74,0.04)',
      borderRadius: '8px',
    },
  },
}))
